// // src/pages/user/Certifications.jsx
// import React, { useState, useEffect } from 'react';
// import CertificationBadge from '../../components/user/CertificationBadge';
// import ZambiaAuthorities from '../../components/user/ZambiaAuthorities';
// import { getCertifications } from '../../utils/api'; // Use getCertifications instead of getActiveCertifications
// import { FaCertificate } from 'react-icons/fa';

// const Certifications = () => {
//   const [certifications, setCertifications] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadCertifications();
//   }, []);

//   const loadCertifications = async () => {
//     try {
//       const certsData = await getCertifications(); // Use getCertifications which gets all certifications
      
//       let certsArray = [];
      
//       // Process certifications data
//       if (Array.isArray(certsData)) {
//         certsArray = certsData;
//       } else if (certsData && certsData.data && Array.isArray(certsData.data.data)) {
//         certsArray = certsData.data.data;
//       } else if (certsData && certsData.data && Array.isArray(certsData.data)) {
//         certsArray = certsData.data;
//       }
      
//       // Filter only active certifications
//       const activeCertifications = certsArray.filter(cert => 
//         cert.is_active !== false
//       );
      
//       // Sort certifications with Zambia authorities first
//       const sortedCerts = [...activeCertifications].sort((a, b) => {
//         // Zambia authorities first
//         const zambiaAuths = ['PACRA', 'ZRA', 'ZPPA', 'NCC', 'WCFCB', 'NAPSA'];
//         const aAuthority = a.authority_acronym || a.issuing_authority;
//         const bAuthority = b.authority_acronym || b.issuing_authority;
//         const aIsZambia = zambiaAuths.includes(aAuthority);
//         const bIsZambia = zambiaAuths.includes(bAuthority);
        
//         if (aIsZambia && !bIsZambia) return -1;
//         if (!aIsZambia && bIsZambia) return 1;
        
//         // Then by display order
//         return (a.display_order || 0) - (b.display_order || 0);
//       });
      
//       setCertifications(sortedCerts);
      
//     } catch (error) {
//       console.error('Error loading certifications:', error);
//       setCertifications([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pt-24 pb-16">
//         <div className="container-custom">
//           <div className="text-center py-20">
//             <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-6 animate-pulse">
//               <div className="h-10 w-10 bg-blue-200 rounded"></div>
//             </div>
//             <div className="h-10 bg-blue-100 rounded w-80 mx-auto mb-4 animate-pulse"></div>
//             <div className="h-4 bg-blue-100 rounded w-64 mx-auto animate-pulse"></div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* ADDED HERO SECTION - ONLY THIS IS NEW */}
//       <section className="bg-gradient-to-r from-blue-900 to-gray-900 text-white py-20">
//         <div className="container-custom">
//           <div className="max-w-3xl">
//             <h1 className="text-5xl font-bold mb-6">Our Certifications</h1>
//             <p className="text-xl text-blue-100">
//               Official accreditations, registrations, and certifications from recognized authorities in Zambia
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* REST OF YOUR ORIGINAL CODE - UNCHANGED */}
//       <div className="bg-gradient-to-b from-gray-50 to-white pt-16 pb-16">
//         {/* Header */}
//         <div className="container-custom mb-12">
//           <div className="text-center">
//             <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full mb-6 shadow-lg">
//               <FaCertificate className="h-10 w-10 text-white" />
//             </div>
//             <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Our Certifications</h1>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Official accreditations, registrations, and certifications from recognized authorities
//             </p>
//             <p className="text-lg text-gray-500 mt-4">
//               Showing all {certifications.length} certifications
//             </p>
//           </div>
//         </div>

//         {/* Zambia Authorities Overview */}
//         <ZambiaAuthorities certifications={certifications} />

//         {/* Certifications Display - Simplified */}
//         <div className="container-custom mt-16">
//           {certifications.length === 0 ? (
//             <div className="text-center py-20 bg-white rounded-2xl shadow-sm">
//               <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-6">
//                 <FaCertificate className="h-10 w-10 text-blue-600" />
//               </div>
//               <h3 className="text-2xl font-bold text-gray-700 mb-3">No Certifications Available</h3>
//               <p className="text-gray-600 max-w-md mx-auto">
//                 Our certification portfolio is currently being updated. Please check back soon.
//               </p>
//             </div>
//           ) : (
//             <>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {certifications.map(cert => (
//                   <CertificationBadge key={cert.id} certification={cert} />
//                 ))}
//               </div>
              
//               {/* Back to Home Button */}
//               <div className="text-center mt-12">
//                 <a
//                   href="/"
//                   className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl"
//                 >
//                   Back to Home
//                   <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
//                   </svg>
//                 </a>
//               </div>
//             </>
//           )}

//           {/* Compliance Statement */}
//           <div className="mt-16 bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 md:p-10 border border-blue-200">
//             <div className="max-w-4xl mx-auto text-center">
//               <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
//                 Commitment to Compliance
//               </h3>
//               <p className="text-lg text-gray-700 mb-6">
//                 Brasotech Investments Limited is committed to maintaining full compliance with all regulatory requirements. 
//                 Our certifications demonstrate our dedication to operating with integrity, transparency, and adherence to 
//                 the highest standards of business practice in Zambia.
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4 justify-center">
//                 <a 
//                   href="/" 
//                   className="inline-flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
//                 >
//                   Back to Home
//                 </a>
//                 <a 
//                   href="/contact" 
//                   className="inline-flex items-center justify-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold border border-blue-600 hover:bg-blue-50 transition-colors"
//                 >
//                   Request Verification
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Certifications;


// src/pages/user/Certifications.jsx
import React from 'react';
import ZambiaAuthorities from '../../components/user/ZambiaAuthorities';
import { FaCheckCircle, FaShieldAlt, FaBalanceScale, FaFileContract, FaUsers, FaCertificate } from 'react-icons/fa';

const Certifications = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-800 text-white py-20">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6 backdrop-blur-sm">
              <FaShieldAlt className="h-10 w-10" />
            </div>
            <h1 className="text-5xl font-bold mb-6">Compliance & Certifications</h1>
            <p className="text-xl text-blue-100 mb-8">
              Brasotech Investments Limited is fully registered and compliant with all relevant Zambian regulatory authorities
            </p>
            <div className="inline-flex items-center bg-white/10 px-4 py-2 rounded-full backdrop-blur-sm">
              <FaCheckCircle className="h-5 w-5 mr-2" />
              <span className="font-medium">Fully Compliant & Registered</span>
            </div>
          </div>
        </div>
      </section>

      {/* Zambia Authorities Section */}
      <ZambiaAuthorities />

      {/* Compliance Statement */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Compliance Commitment</h2>
              <p className="text-xl text-gray-600">
                We operate with integrity and transparency in full compliance with Zambian laws and regulations
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-4">
                  <FaShieldAlt className="h-6 w-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Legal Compliance</h3>
                <p className="text-gray-600">
                  Fully registered and compliant with all Zambian regulatory bodies and government agencies
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 rounded-full mb-4">
                  <FaBalanceScale className="h-6 w-6 text-green-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Ethical Standards</h3>
                <p className="text-gray-600">
                  Adhering to the highest ethical standards in all business operations and client engagements
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 rounded-full mb-4">
                  <FaUsers className="h-6 w-6 text-purple-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Client Assurance</h3>
                <p className="text-gray-600">
                  Providing our clients with confidence through our registered status and compliance verification
                </p>
              </div>
            </div>

            {/* Compliance Details */}
            <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200">
              <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                Regulatory Compliance Details
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <FaCheckCircle className="h-6 w-6 text-green-500 mr-4 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Company Registration</h4>
                    <p className="text-gray-600">
                      Fully registered with the Patents and Company Registration Agency (PACRA) and compliant with all company laws and regulations.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <FaCheckCircle className="h-6 w-6 text-green-500 mr-4 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Tax Compliance</h4>
                    <p className="text-gray-600">
                      Registered with the Zambia Revenue Authority (ZRA) and fully compliant with all tax regulations and reporting requirements.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <FaCheckCircle className="h-6 w-6 text-green-500 mr-4 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Industry Compliance</h4>
                    <p className="text-gray-600">
                      Registered with relevant industry bodies including the National Council For Construction (NCC) where applicable.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <FaCheckCircle className="h-6 w-6 text-green-500 mr-4 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Public Procurement</h4>
                    <p className="text-gray-600">
                      Registered with the Zambia Public Procurement Authority (ZPPA) for participation in government tenders and contracts.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <FaCheckCircle className="h-6 w-6 text-green-500 mr-4 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Employee Welfare</h4>
                    <p className="text-gray-600">
                      Compliant with Workers' Compensation Fund Control Board (WCFCB) and National Pension Scheme Authority (NAPSA) regulations.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-12">
              <p className="text-lg text-gray-600 mb-6">
                For verification of our registration status or to request compliance documentation
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="/contact" 
                  className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  Request Verification
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
                <a 
                  href="/" 
                  className="inline-flex items-center justify-center bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold border border-blue-600 hover:bg-blue-50 transition-colors"
                >
                  Back to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Certifications;